import React, { Component } from 'react';
import IosSwitch from '../IosSwitch';
import DefaultButton from '../DefaultButton';
import DefaultLoader from '../DefaultLoader';
import SessionHelper from '../../helper/SessionHelper';
import ReportHelper from '../../helper/ReportHelper';
import moment from 'moment';
import Firestore from '../../api/firebase/Firestore';
import { toast } from 'react-toastify';
import { FormLabel, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import Colors from '../../constants/Colors';
import CurrencyHelper from '../../helper/CurrencyHelper';
import ReportDefaultModalOptions from './ReportDefaultModalOptions';

export default class TicketsInPeriodReport extends Component {

    state = {
        loadingModal: true,
        serviceDocs: [],
        productDocs: [],
        salesUserDocs: [],
        adminDocs: [],
        locationDocs: [],
        services: [],
        products: [],
        admins: [],
        paymentMethods: [],
        saleUsers: [],
        locations: [],
        allPaymentMethods: true,
        allSalesUsers: true,
        allServices: true,
        allProducts: true,
        allAdmins: true,
        allLocations: true,
        start: moment().startOf('month').startOf('day').toDate(),
        end: moment().endOf('day').toDate(),
        orderItems: false,
        ticketsInPeriodOrder: 'date',
        output: 'download',
        format: 'pdf',
    }

    async componentDidMount() {

        if (this.props.getDocs && this.props.getDocs) {

            for (let index = 0; index < this.props.getDocs.length; index++) {
                
                const getDoc = this.props.getDocs[index];
                await getDoc(this);
            }
        }

        this.setState({ loadingModal: false });
    }

    async getReportDocs() {

        let start = moment(this.state.start).startOf('day').toDate();
        let end = moment(this.state.end).endOf('day').toDate();
        let query = await Firestore.customQuery('order').where('id_company', '==', SessionHelper.getData().id_company).where('date', '>=', start).where('date', '<=', end).where('type', 'in', ['ticket']).orderBy('date', 'desc').get();

        let productDocs = [ ...this.state.productDocs, ...this.state.serviceDocs ];
        let products = this.state.allProducts ? this.state.productDocs.map((product) => { return product.id }) : this.state.products;
        let services = this.state.allServices ? this.state.serviceDocs.map((service) => { return service.id }) : this.state.services;
        let saleUsers = this.state.allSalesUsers ? this.state.salesUserDocs.map((user) => { return user.id }) : this.state.saleUsers;
        let admins = this.state.allAdmins ? this.state.adminDocs.map((admin) => { return admin.id }) : this.state.admins;
        let locations = this.state.allLocations ? this.state.locationDocs.map((location) => { return location.id }) : this.state.locations;

        let orders = [];
        let totalAmount = 0;
        let paidAmount = 0;
        let count = 0;
        let docs = [];

        query.forEach((orderDoc, key) => {

            orders.push({ ...orderDoc.data(), id: orderDoc.id });
        });

        if (this.state.ticketsInPeriodOrder !== 'date') {

            orders.sort((a, b) => {

                if (this.state.ticketsInPeriodOrder === 'amount') {

                    return a.amount < b.amount;

                } else if (this.state.ticketsInPeriodOrder === 'user') {
                    
                    let user = this.state.salesUserDocs.find(item => item.id === a.id_user);
                    let bUser = this.state.salesUserDocs.find(item => item.id === b.id_user);

                    let name = 'Usuário Desconhecido';
                    let bName = 'Usuário Desconhecido';

                    if (user) { name = user.name };
                    if (bUser) { bName = bUser.name };

                    return name > bName;

                } else if (this.state.ticketsInPeriodOrder === 'admin') {
                    
                    let user = this.state.adminDocs.find(item => item.id === a.created_by);
                    let bUser = this.state.adminDocs.find(item => item.id === b.created_by);

                    let name = 'Usuário Desconhecido';
                    let bName = 'Usuário Desconhecido';

                    if (user) { name = user.name };
                    if (bUser) { bName = bUser.name };

                    return name > bName;
                }
            });
        }

        orders.forEach((order, key) => {

            if (order.payment_method === 'credit-card') { order.payment_method = 'credit_card' };
            
            if ((this.state.allAdmins || admins.includes(order.created_by)) && (this.state.allSalesUsers || saleUsers.includes(order.id_user)) && (this.state.allPaymentMethods || this.state.paymentMethods.includes(order.payment_method))) {

                let orderItems = order.items;
                let items = [...products, ...services];
                let client = this.state.salesUserDocs.find(item => item.id === order.id_user);
                let user = this.state.adminDocs.find(item => item.id === order.created_by);

                let findProduct = false;
                let findLocation = this.state.allLocations ? true : false;

                let paidValue = 0;
                if (order.history) order.history.map(history => { paidValue += history.amount });

                order.paid_amount = paidValue;
                
                if (orderItems && orderItems.length) {

                    orderItems.forEach((item, key) => {
                                            
                        if (!findProduct && item.id && items.findIndex(product => product === item.id) >= 0) {

                            findProduct = true;
                        }

                        if (!findLocation && item.id) {

                            locations.forEach((location, key) => {

                                let product = productDocs.find(product => product.id === item.id);
                                
                                if (product.id_location === location) {
    
                                    findLocation = true;
                                }
                            });
                        }
                    });
                }

                if (findProduct && findLocation) {

                    totalAmount += order.amount;
                    paidAmount += paidValue;
                    count ++;

                    let status = '';

                    if (order.payment_method === 'money') {

                        if (order.finished && !order.refunded && !order.canceled) {
            
                            status = 'Pago';
                        
                        } else if (order.finished && order.refunded) {
            
                            status = 'Estornado';
            
                        } else if (order.canceled) {
            
                            status = 'Cancelado';
            
                        } else {
            
                            status = 'Aguardando Pagamento';
                        }
            
                    } else {
            
                        if (order.status === 'paid' || !order.status) {
            
                            if (order.refunded) {
                
                                status = 'Estornado';
                
                            } else if (order.canceled) {
            
                                status = 'Cancelado';
            
                            } else {
                
                                status = 'Pago';
                            }
                        
                        } else if (order.status === 'waiting_payment' && !order.canceled && !order.refunded) {
                            
                            status = 'Aguardando Pagamento';
            
                        } else if (order.canceled && !order.refunded) {
            
                            status = 'Cancelado';
            
                        } else {
            
                            status = 'Estornado';
                        }
                    }

                    docs.push({
                        order,
                        order_items: orderItems,
                        client: client,
                        user: user,
                        status: status,
                    });
                }
            }
        });

        return { docs: docs, totalizer: [{ count: count, total_amount: totalAmount, paid_amount: paidAmount }] };
    }

    getColor(report, doc) {

        if (doc.order.payment_method === 'money') {

            if (doc.order.finished && !doc.order.refunded && !doc.order.canceled) {

                report.doc.setTextColor(89, 166, 61);
            
            } else if (doc.order.finished && doc.order.refunded) {

                report.doc.setTextColor(156, 64, 255);

            } else if (doc.order.canceled) {

                report.doc.setTextColor(156, 64, 255);

            } else {

                report.doc.setTextColor(240, 144, 0);
            }

        } else {

            if (doc.order.status === 'paid' || !doc.order.status) {

                if (doc.order.refunded) {
    
                    report.doc.setTextColor(156, 64, 255);
    
                } else if (doc.order.canceled) {

                    report.doc.setTextColor(156, 64, 255);

                } else {

                    report.doc.setTextColor(89, 166, 61);
                }
            
            } else if (doc.order.status === 'waiting_payment' && !doc.order.canceled && !doc.order.refunded) {
                
                report.doc.setTextColor(240, 144, 0);

            } else if (doc.order.canceled && !doc.order.refunded) {

                report.doc.setTextColor(156, 64, 255);

            } else {

                report.doc.setTextColor(156, 64, 255);
            }
        }
    }

    addThree(report, column) {

        report.doc.setLineWidth(0.6);
        report.doc.line(column.width - 0.3, report.offset + 4, 18, report.offset + 4);
        report.doc.line(column.width, report.offset + 4, column.width, report.offset + 2);
        report.doc.setLineWidth(0.2);
    }

    async print() {

        if (this.state.start && this.state.end) {

            this.setState({ loadingModal: true });

            let name = `Comandas por Cliente - ${SessionHelper.getData().company.name} - ${moment().format('DD/MM/YYYY')}`;
            let subtitle = `De ${moment(this.state.start).format('DD/MM/YYYY')} até ${moment(this.state.end).format('DD/MM/YYYY')}`;
            let docs = await this.getReportDocs();
            let report = await ReportHelper.createReport(name, 5, subtitle);

            let createOrderItemsColumn = async () => { };

            if (this.state.orderItems) {

                createOrderItemsColumn =  async (report, actualDoc) => {

                    report = await ReportHelper.createColumns(report, actualDoc.order_items, [
                        { name: '', width: 14, getText: (doc) => '', customColumnHeader: (report, column) => this.addThree(report, column) },
                        { name: 'Produto', width: 20, getText: (doc) => doc.title },
                        { name: 'Quantidade', width: 115, getText: (doc) => doc.quantity.toString() },
                        { name: 'Valor Unitário', width: 150, getText: (doc) => CurrencyHelper.centsToMoney(doc.unit_price) },
                    ], null, false, 6, [237, 237, 237]);

                    return report;
                }
            }

            report = await ReportHelper.createColumns(report, docs.docs, [
                { name: 'Comanda', width: 13, getText: (doc) => doc.order.title },
                { name: 'Valor', width: 47, getText: (doc) => `${CurrencyHelper.centsToMoney(doc.order.amount - doc.order.discount)} (${CurrencyHelper.centsToMoney(doc.order.paid_amount)} pagos)` },
                { name: 'Cliente', width: 95, getText: (doc) => doc.client && doc.client.name ? ReportHelper.treatName(doc.client.name) : '' },
                { name: 'Usuário', width: 115, getText: (doc) => doc.user && doc.user.name ? ReportHelper.treatName(doc.user.name) : '' },
                { name: 'Status', width: 136, getColor: (report, doc) => this.getColor(report, doc), getText: (doc) => doc.status.split(' ')[0] },
                { name: 'Data de Vencimento', width: 163, getText: (doc) => moment(doc.order.end.toDate()).format('DD/MM/YYYY HH:mm') },
            ], (report, actualDoc) => createOrderItemsColumn(report, actualDoc));
    
            report = await ReportHelper.createColumns(report, docs.totalizer, [
                { name: 'Total de Comandas', width: 95, getText: (doc) => doc.count.toString() },
                { name: 'Valor Total', width: 136, getText: (doc) => CurrencyHelper.centsToMoney(doc.total_amount)},
                { name: 'Valor Recebido', width: 171, getText: (doc) => CurrencyHelper.centsToMoney(doc.paid_amount)},
            ], null, false, 6);

            ReportHelper.print(report, this.state.output, this.state.format);

            this.setState({ loadingModal: false });

        } else {

            toast.warn('Preencha o período do relatório');
        }
    }

    renderLoading() {

        return (

            <div style={{ height: 200 }}>
                <DefaultLoader/>
            </div>
        )
    }

    renderModal() {

        return (

            <div>
                <IosSwitch fullWidth label={'Todos os Produtos'} checked={this.state.allProducts} onChange={(e) => { this.setState({ allProducts: e, products: [] }) }} />
                { !this.state.allProducts ? ReportHelper.renderProductSelection(this, this.state.productDocs, 'products') : null }

                <IosSwitch fullWidth label={'Todos os Serviços'} checked={this.state.allServices} onChange={(e) => { this.setState({ allServices: e, services: [] }) }} />
                { !this.state.allServices ? ReportHelper.renderServiceSelection(this, this.state.serviceDocs, 'services') : null }

                <IosSwitch fullWidth label={'Todos os Clientes'} checked={this.state.allSalesUsers} onChange={(e) => { this.setState({ allSalesUsers: e, saleUsers: [] }) }} />
                { !this.state.allSalesUsers ? ReportHelper.renderSalesUserSelection(this, this.state.salesUserDocs, 'saleUsers') : null }

                <IosSwitch fullWidth label={'Todos os Administradores'} checked={this.state.allAdmins} onChange={(e) => { this.setState({ allAdmins: e, admins: [] }) }} />
                { !this.state.allAdmins ? ReportHelper.renderAdminSelection(this, this.state.adminDocs, 'admins') : null }

                <IosSwitch fullWidth label={'Todos os Métodos de Pagamento'} checked={this.state.allPaymentMethods} onChange={(e) => { this.setState({ allPaymentMethods: e, paymentMethods: [] }) }} />
                { !this.state.allPaymentMethods ? ReportHelper.renderPaymentMethodSelection(this, 'paymentMethods', 'order') : null }

                <IosSwitch fullWidth label={'Todos os Locais'} checked={this.state.allLocations} onChange={(e) => { this.setState({ allLocations: e, locations: [] }) }} />
                { !this.state.allLocations ? ReportHelper.renderLocationSelection(this, this.state.locationDocs, 'locations') : null }

                <IosSwitch fullWidth label={'Exibir Itens da Venda'} checked={this.state.orderItems} onChange={(e) => { this.setState({ orderItems: e }) }} />

                <div style={{ marginTop: 15 }}/>

                { ReportHelper.renderPeriodSelection(this, 'start', 'end') }

                <FormLabel style={{ marginTop: 18, fontWeight: '800' }} component="legend">Ordenação</FormLabel>
                <div style={{ flexDirection: 'row', paddingTop: 10 }}>
                    <RadioGroup style={{ display: 'flex', flexDirection: 'row' }} value={this.state.ticketsInPeriodOrder} onChange={(evt) => { this.setState({ ticketsInPeriodOrder: evt.target.value }) }}>
                        <FormControlLabel value="date" control={<Radio style={{ color: Colors.primary }} />} label="Data" />
                        <FormControlLabel value="amount" control={<Radio style={{ color: Colors.primary }} />} label="Valor" />
                        <FormControlLabel value="user" control={<Radio style={{ color: Colors.primary }} />} label="Cliente" />
                        <FormControlLabel value="admin" control={<Radio style={{ color: Colors.primary }} />} label="Administrador" />
                    </RadioGroup>
                </div>
                <ReportDefaultModalOptions onOutputChange={(value) => { this.setState({ output: value }) }} onFormatChange={(value) => { this.setState({ output: value }) }}/>
                <div style={{alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: 50}}>
                    <DefaultButton width={'100%'} title={'Imprimir'} onClick={() => { this.print() }} />
                </div>
            </div>
        )
    }

    render() {

        return (

            this.state.loadingModal ? this.renderLoading() : this.renderModal()
        )
    }
}